// Under Next's 1 MB API body limit with room for the request envelope.
export const MAX_BATCH_BYTES = 700_000
export const MAX_BATCH_ROWS = 25

const byteSize = (value: unknown) =>
	new TextEncoder().encode(JSON.stringify(value)).length

/** Splits the rows into requests the API accepts; a row too big to send on its own is returned apart. */
export function batchChangelogImports<T>(
	rows: T[],
	{ maxBytes = MAX_BATCH_BYTES, maxRows = MAX_BATCH_ROWS } = {},
): { batches: T[][]; tooLarge: T[] } {
	const batches: T[][] = []
	const tooLarge: T[] = []
	let current: T[] = []
	let currentBytes = 0

	for (const row of rows) {
		const size = byteSize(row)
		if (size > maxBytes) {
			tooLarge.push(row)
			continue
		}
		if (
			current.length > 0 &&
			(current.length >= maxRows || currentBytes + size > maxBytes)
		) {
			batches.push(current)
			current = []
			currentBytes = 0
		}
		current.push(row)
		currentBytes += size
	}
	if (current.length > 0) batches.push(current)
	return { batches, tooLarge }
}
